export async function updateProductDetailedStockUseCase(detail_data, detailedStockRepository) {
    const detailed_stock = new detailedStockRepository.model(detail_data);
  
    const is_valid = detailed_stock.isValid();

    if (is_valid != true) {
      throw new Error(is_valid);
    }
  
    return detailedStockRepository.update_product_detailed_stock(detailed_stock.id, detailed_stock);
}